/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useState } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import {
  Card,
  CardBody,
  Flex,
  useToast,
  useBreakpointValue,
} from "@chakra-ui/react";
import * as XLSX from "xlsx";

import EscalationMatrixFilterBar from "../../components/escalationMatrix/filter-bar";
import {
  useGetEscalationMatrixAll,
  useDeleteEscalationMatrix,
} from "../../services/escalation-matrix";
import { ActionCell, StatusCell } from "./escalationMatrixCells";
import BreadCrumb from "components/breadCrumb";
import { Paths } from "routes/paths";

const pageSize = 25;

const cellStyle = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

export default function EscalationMatrixList() {
  const toast = useToast();

  const showWideColumns = useBreakpointValue({
    base: false,
    md: true,
  });

  const [escalations, setEscalations] = useState([]);
  const [dataState, setDataState] = useState({ skip: 0, take: pageSize });
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({ searchCriteria: "" });

  const { mutate: getAll } = useGetEscalationMatrixAll();
  const { mutate: deleteMatrix } = useDeleteEscalationMatrix();

  const fetchList = (page = 1) => {
    getAll(
      {
        pageNumber: page,
        pageRowCount: pageSize,
        searchCriteria: filters.searchCriteria,
      },
      {
        onSuccess: (res) => {
          if (Array.isArray(res?.data)) {
            setEscalations(res.data);
            setTotalRecords(res.data.length);
          }
        },
      }
    );
  };

  useEffect(() => {
    fetchList(currentPage);
  }, [filters]);

  const onPageChange = (e) => {
    const page = e.page.skip / pageSize + 1;
    setCurrentPage(page);
    fetchList(page);
  };

  const handleDelete = (id) => {
    deleteMatrix(id, {
      onSuccess: () => {
        setEscalations((prev) => prev.filter((i) => i.id !== id));
        toast({
          title: "Escalation deleted successfully",
          status: "success",
          isClosable: true,
        });
        fetchList(currentPage);
      },
      onError: (err) => {
        toast({
          title: "Delete failed",
          description: err.message || "Something went wrong",
          status: "error",
          isClosable: true,
        });
      },
    });
  };

  const handleExport = () => {
    getAll(
      {
        pageNumber: 1,
        pageRowCount: 10000,
        searchCriteria: filters.searchCriteria,
      },
      {
        onSuccess: (res) => {
          const data = res?.data || [];
          if (!data.length) {
            toast({
              title: "No data found",
              description:
                "No escalation matrix records exist for the selected filters",
              status: "info",
              isClosable: true,
            });
            return;
          }

          const excelRows = data.map((item) => ({
            Name: item.name,
            Designation: item.designation,
            AssignmentGroup: item.assignmentGroup,
            Region: item.region?.join(", ") || "-",
            Activities: item.activityTypes?.join(", ") || "-",
            EscalationLevel: item.escalationLevel?.join(", ") || "-",
            Emails: item.emails?.join(", ") || "-",
            Status: item.isActive ? "Active" : "Inactive",
          }));

          const workbook = XLSX.utils.book_new();
          const worksheet = XLSX.utils.json_to_sheet(excelRows);
          XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Escalation Matrix"
          );
          XLSX.writeFile(workbook, "Escalation_Matrix.xlsx");

          toast({
            title: "Export successful",
            status: "success",
            isClosable: true,
          });
        },
        onError: (err) => {
          toast({
            title: "Export failed",
            description: err.message || "Something went wrong",
            status: "error",
            isClosable: true,
          });
        },
      }
    );
  };

  return (
    <Flex className="main-container" direction="column">
      <Flex px="20px">
        <BreadCrumb
          links={[
            { text: "Dashboard", link: Paths.dashboard },
            { text: "Escalation Matrix", isCurrentPage: true },
          ]}
        />
      </Flex>
      <Card m="20px">
        <CardBody>
          <EscalationMatrixFilterBar
            getList={(search) => setFilters({ searchCriteria: search })}
            onExport={handleExport}
          />

          <Flex overflowX="auto">
            <Grid
              data={process(escalations || [], dataState)}
              {...dataState}
              resizable
              reorderable
              scrollable="scrollable"
              style={{ minWidth: "1100px" }}
              filterable
              sortable
              pageable
              total={totalRecords}
              pageSize={pageSize}
              skip={(currentPage - 1) * pageSize}
              onPageChange={onPageChange}
              onDataStateChange={(e) => setDataState(e.dataState)}
            >
              <Column
                field="name"
                title="Group Name"
                minWidth={180}
                cell={(p) => <td style={cellStyle}>{p.dataItem.name}</td>}
              />

              <Column
                field="designation"
                title="Description"
                minWidth={160}
                cell={(p) => (
                  <td style={cellStyle}>{p.dataItem.designation}</td>
                )}
              />

              <Column
                field="assignmentGroup"
                title="Assignment Group"
                minWidth={180}
                cell={(p) => (
                  <td style={cellStyle}>{p.dataItem.assignmentGroup}</td>
                )}
              />

              <Column
                title="Region"
                minWidth={180}
                cell={({ dataItem }) => (
                  <td style={cellStyle}>
                    {dataItem.region?.join(", ") || "-"}
                  </td>
                )}
              />

              {showWideColumns ? (
                <Column
                  title="Activities"
                  minWidth={200}
                  cell={({ dataItem }) => (
                    <td style={cellStyle}>
                      {dataItem.activityTypes?.join(", ") || "-"}
                    </td>
                  )}
                />
              ) : null}

              {showWideColumns ? (
                <Column
                  title="Escalation Level"
                  Width={160}
                  cell={({ dataItem }) => (
                    <td style={cellStyle}>
                      {dataItem.escalationLevel?.join(", ") || "-"}
                    </td>
                  )}
                />
              ) : null}

              {showWideColumns ? (
                <Column
                  title="Email"
                  minWidth={220}
                  cell={({ dataItem }) => (
                    <td style={cellStyle}>
                      {dataItem.emails?.join(", ") || "-"}
                    </td>
                  )}
                />
              ) : null}

              <Column
                title="Status"
                minWidth={100}
                className="text-center"
                headerClassName="text-center"
                cell={({ dataItem }) => <StatusCell dataItem={dataItem} />}
              />

              <Column
                title="Actions"
                minWidth={120}
                className="text-center"
                headerClassName="text-center"
                cell={({ dataItem }) => (
                  <ActionCell dataItem={dataItem} onDelete={handleDelete} />
                )}
              />
            </Grid>
          </Flex>
        </CardBody>
      </Card>
    </Flex>
  );
}
